var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2480_1369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 12V8C1 6.34315 2.34315 5 4 5H8C9.65685 5 11 6.34315 11 8V12C11 13.6569 9.65685 15 8 15H4C2.34315 15 1 13.6569 1 12Z",
    stroke: "#0C5EFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3V3C5 1.89543 5.89543 1 7 1H12C13.6569 1 15 2.34315 15 4V9C15 10.1046 14.1046 11 13 11V11",
    stroke: "#0C5EFF",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2480_1369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCopyIcon);
export default __webpack_public_path__ + "static/media/clipboard-copy-icon.08286f8e8ff2b5bff2b58056218f9cd6.svg";
export { ForwardRef as ReactComponent };